import { assertReframeGeometry } from "@shared/reframe-geometry";
import type { AspectRatio } from "@shared/aspectRatios";

// Measure the actual returned file, not the response's requested-ratio label.
// No generation or retry is performed here.
export async function validateReframePreview(url: string, ratio: AspectRatio): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    const image = new Image();
    const timer = setTimeout(() => reject(new Error("Couldn't verify preview dimensions. The preview has not been saved.")), 15000);
    image.onload = () => {
      clearTimeout(timer);
      try {
        assertReframeGeometry(image.naturalWidth, image.naturalHeight, ratio);
        resolve();
      } catch (error) { reject(error); }
    };
    image.onerror = () => {
      clearTimeout(timer);
      reject(new Error("Couldn't load the preview to verify its dimensions. The preview has not been saved."));
    };
    image.src = url;
  });
}
